import { request } from "../request";
import { InterceptPrefix,checkImageBase,checkListImageBase,InterceptListPrefix,completionListImageBase } from '../utils';

export const becomeSellerAdd = (params) => {
    return request({
        method: 'post',
        url: '/become-seller-reqs/add',
        params
    })
}

export const getSellerList = (params) => {
    return request({
        method: 'post',
        url: '/become-seller-reqs/getall',
        params
    })
}

export const getSellerDetails = (id) => {
    return request({
        method: 'get',
        url: '/become-seller-reqs/details/'+id,
    }).then((res)=>{
        const {businessRegCert,wineListFileUrl,hkidPassportFileUrl}=res;
        businessRegCert&&(res.businessRegCert=checkImageBase(businessRegCert));
        (wineListFileUrl&&wineListFileUrl.length)&&(res.wineListFileUrl=completionListImageBase(wineListFileUrl));
        hkidPassportFileUrl&&(res.hkidPassportFileUrl=checkImageBase(hkidPassportFileUrl));
        return res;
    })
}

//成为卖家编辑
export const becomeSellerManage = (params) => {
    const {businessRegCert,wineListFileUrl,hkidPassportFileUrl}=params;
    // businessRegCert&&(params.businessRegCert=InterceptPrefix(businessRegCert));
    // (wineListFileUrl&&wineListFileUrl.length)&&(params.wineListFileUrl=InterceptListPrefix(wineListFileUrl));
    // hkidPassportFileUrl&&(params.hkidPassportFileUrl=InterceptPrefix(hkidPassportFileUrl));
    return request({
        method: 'post',
        url: '/become-seller-reqs/manage',
        params
    })
}
